import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Chip, Link, Grid, Typography, Container, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, FormControl, InputLabel, MenuItem, Select, OutlinedInput, Button } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import PayPalButton from '../components/payments/PayPalButton';
import CheckoutButton from '../components/payments/2CheckoutButton';
import PayuButton from '../components/payments/PayuButton';
import { getInvoiceClient, updatePaymentMethod } from '../services/Invoice';
import downloadInvoicePdf from '../services/InvoicePdf';
import DownloadIcon from '@material-ui/icons/Download';
import PdfIcon from '@material-ui/icons/PictureAsPdf';
import SpinnerLoad from '../components/FormsUI/Spinner';
import LoadingButton from '@mui/lab/LoadingButton';
import { logout } from '../hooks/useAuth'
import { useNavigate } from 'react-router-dom';
import StripeButtonPayElement from '../components/payments/StripeButtonPayElement';
import TooltipInvoiceDetail from '../components/Invoices/TooltipInvoiceDetail';
import { useTranslation } from 'react-i18next';

const Invoice = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const { id } = useParams();
    const [payment, setPayment] = useState(null);
    const [invoice, setInvoice] = useState(null);

    const [errorInvoice, setErrorInvoice] = useState(false);

    const [loading, setLoading] = useState(false);


    const handleChangePayment = async (ev) => {
        //console.log('valor payment', ev.target.value)

        const values = {
            invoiceid: invoice.invoiceid,
            paymentmethod: ev.target.value
        }

        const pgupdated = await updatePaymentMethod(values);

        setPayment(ev.target.value)

    }

    const handleInvoicePdf = async () => {
        setLoading(true);
        const id = invoice.invoiceid;
        const res = await downloadInvoicePdf(id);

        if (res.error === false) {
            setLoading(false);
        }
    }

    useEffect(() => {

        const getInvoice = async () => {
            const data = await getInvoiceClient(id);

            if (data.error === true) {
                if (data.message.status === 401) {
                    logout();
                    navigate('/', { replace: true });
                }
                setErrorInvoice(true);
            }
            if (data.error === false) {
                setInvoice(data);
                setPayment(data.invoicepayment);
            }
        }

        getInvoice();

    }, [])


    if (invoice === null || payment === null) {
        return (
            <>
                {errorInvoice ?
                    <Container maxWidth="sm" variant='cont-nk'>

                        <Box sx={{ mb: 2, mt: 3 }}>
                            <Typography
                                color="textPrimary"
                                variant="h2"
                                align="center"
                            >
                                {t('sorry')}
                            </Typography>

                        </Box>

                        <Box sx={{ pt: 1, pb: 2 }}>
                            <Typography
                                color="textSecondary"
                                gutterBottom
                                variant="body1"
                                align="center"
                            >
                                {t('invoiceAccessError')}
                            </Typography>

                        </Box>

                    </Container>

                    :
                    <SpinnerLoad />
                }
            </>
        )
    } else {
        return (
            <>
                <Helmet>
                    <title>{t('clientAreaTitle')} - {`Invoice #${invoice.invoiceid}`}</title>
                </Helmet>
                <Box>
                    <Container maxWidth="lg" variant='cont-nk' sx={{ pb: 4, pt: 2 }}>
                        <Grid container spacing={2}>
                            {invoice.invoicestatus === 'Unpaid' ?
                                <Grid item xs={12} sm={12} md={8} >
                                    <Grid container sx={{ backgroundColor: '#f8f8f8' }} mt={3} mb={3} pb={2}>

                                        <Grid item xs={8}>
                                            <Box sx={{ paddingTop: '16px', paddingLeft: '10px' }}>
                                                <Typography variant='h4' sx={{ display: 'inline', pr: 1 }}>{t('invoice')} #{invoice.invoiceid}</Typography>
                                                {invoice.invoicestatus === 'Unpaid' &&
                                                    <Chip color="secondary" size="small" label={invoice.invoicestatus} sx={{ borderRadius: 1, marginTop: '-4px', height: '20px', backgroundColor: '#E3E8EE', color: '#53566B' }} />
                                                }
                                                {invoice.invoicestatus === 'Paid' &&
                                                    <Chip size="small" label={invoice.invoicestatus} sx={{ borderRadius: 1, marginTop: '-4px', height: '20px', backgroundColor: '#cbf4c9', color: '#268717' }} />
                                                }
                                                {invoice.invoicestatus === 'Cancelled' &&
                                                    <Chip size="small" label={invoice.invoicestatus} sx={{ borderRadius: 1, marginTop: '-4px', height: '20px', backgroundColor: '#F8DADB', color: '#B72136' }} />
                                                }
                                                {invoice.invoicestatus === 'Refunded' &&
                                                    <Chip size="small" label={invoice.invoicestatus} sx={{ borderRadius: 1, marginTop: '-4px', height: '20px', backgroundColor: '#F8DADB', color: '#B72136' }} />
                                                }
                                            </Box>

                                        </Grid>
                                        <Grid item xs={4} >
                                            {/* <Button variant="outlined" onClick={handleInvoicePdf} startIcon={<DownloadIcon sx={{ mr: 0, ml: 0 }} />} endIcon={<PdfIcon sx={{ ml: 0, mr: 2, color: '#686868' }} />} sx={{ mt: 1.7, mr: 2, padding: '4px 5px' }} ></Button> */}
                                            <Grid container direction="row" justifyContent="flex-end">
                                                <LoadingButton
                                                    onClick={handleInvoicePdf}
                                                    loading={loading}
                                                    variant="outlined"
                                                    endIcon={<DownloadIcon sx={{ mr: 1, ml: 0 }} />}
                                                    loadingPosition="end"
                                                    sx={{ mt: 1.7, mr: 2, padding: '4px 5px' }}
                                                >
                                                    <PdfIcon sx={{ ml: 1, mr: 1, color: '#686868', fontSize: '2rem' }} />

                                                </LoadingButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Box>
                                        <Grid container spacing={5}>
                                            <Grid item xs={6}>
                                                <Typography variant='subtitule1' color='primary'>{t('billTo')}</Typography>
                                                <Typography variant='body2' color="grey.500">{invoice.invoicepayto}</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant='subtitule1' color='primary'>{t('issuedTo')}</Typography>
                                                <Typography variant='body2' color="grey.500">{invoice.client_companyname}</Typography>
                                                <Typography variant='body2' color="grey.500">{invoice.client_firstname} {invoice.client_lastname}</Typography>
                                                <Typography variant='body2' color="grey.500">{invoice.client_address1}</Typography>
                                                <Typography variant='body2' color="grey.500">{invoice.client_city} {invoice.client_state} {invoice.client_postcode}</Typography>
                                                <Typography variant='body2' color="grey.500">{invoice.client_country}</Typography>
                                            </Grid>
                                        </Grid>

                                    </Box>
                                    <Box mt={5} mb={3} >
                                        <Typography variant='h5' sx={{ mb: 2 }} color='primary'>{t('productsServices')}</Typography>

                                        <TableContainer component={Paper} variant="tbLight2-nk">
                                            <Table aria-label="simple table" size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>{t('description')}</strong></TableCell>
                                                        <TableCell align="right"><strong>{t('amount')}</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    
                                                    {invoice.hostings.map((host) => (
                                                        <TableRow hover key={host.id}>
                                                            <TableCell component="th" scope="row">
                                                                {
                                                                    host.description.split("\n").map((item, idx) => (
                                                                        <span key={idx}>
                                                                            {item}
                                                                            <br />
                                                                        </span>

                                                                    ))
                                                                }
                                                                
                                                            </TableCell>
                                                            <TableCell align="right">{invoice.currencyprefix}{host.amount} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                        </TableRow>
                                                    ))}

                                                    {invoice.promos.map((promo) => (
                                                        <TableRow hover key={promo.id}>
                                                            <TableCell component="th" scope="row">
                                                                {promo.description}
                                                            </TableCell>
                                                            <TableCell align="right">{invoice.currencyprefix}{promo.amount} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                        </TableRow>
                                                    ))}


                                                    {invoice.addons.map((addon) => (
                                                        <TableRow hover key={addon.id}>
                                                            <TableCell component="th" scope="row">
                                                                {addon.description}
                                                            </TableCell>
                                                            <TableCell align="right">{invoice.currencyprefix}{addon.amount} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                        </TableRow>
                                                    ))}

                                                    {invoice.domains.map((domain) => (
                                                        <TableRow hover key={domain.id}>
                                                            <TableCell component="th" scope="row">
                                                                {
                                                                    domain.description.split("\n").map((item, idx) => (
                                                                        <span key={idx}>
                                                                            {item}
                                                                            <br />
                                                                        </span>
                                                                    ))
                                                                }
                                                            </TableCell>
                                                            <TableCell align="right">{invoice.currencyprefix}{domain.amount} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                        </TableRow>
                                                    ))}

                                                    {invoice.customitems.map((item) => (
                                                        <TableRow hover key={item.id}>
                                                            <TableCell component="th" scope="row">
                                                                {item.description}
                                                            </TableCell>
                                                            <TableCell align="right">{invoice.currencyprefix}{item.amount} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                        </TableRow>
                                                    ))}

                                                    {invoice.variousitems.map((item) => (
                                                        <TableRow hover key={item.id}>
                                                            <TableCell component="th" scope="row">
                                                                {item.type === "Invoice" ?
                                                                    <>{item.description} <TooltipInvoiceDetail idinvoice={item.relid} /> </>
                                                                    :
                                                                    <>{item.description}</>
                                                                }
                                                            </TableCell>
                                                            <TableCell align="right">{invoice.currencyprefix}{item.amount} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                        </TableRow>
                                                    ))}


                                                    <TableRow>
                                                        <TableCell> <strong>{t('total')}</strong></TableCell>
                                                        <TableCell align="right">{invoice.currencyprefix}{invoice.total} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </Box>

                                    {/* transactions*/}

                                    <Box mt={5} mb={3}>
                                        <Typography variant='h5' sx={{ mb: 2 }} color='primary'>{t('transactions')}</Typography>
                                        <TableContainer component={Paper} variant="tbLight2-nk">
                                            <Table aria-label="simple table" size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>{t('date')}</strong></TableCell>
                                                        <TableCell><strong>{t('paymentMethodGateway')}</strong></TableCell>
                                                        <TableCell><strong>{t('transactionId')}</strong></TableCell>
                                                        <TableCell align="right"><strong>{t('total')}</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {invoice.transactions.length !== 0 &&
                                                        <>
                                                            {invoice.transactions.map((trans) => (
                                                                <TableRow hover key={trans.id}>
                                                                    <TableCell component="th" scope="row">{trans.date}</TableCell>
                                                                    <TableCell>{trans.gateway}</TableCell>
                                                                    <TableCell>{trans.transid}</TableCell>

                                                                    {(trans.amountin !== '0.00' && trans.amountout === '0.00') && <TableCell align="right">{invoice.currencyprefix}{trans.amountin} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>}
                                                                    {(trans.amountout !== '0.00' && trans.amountin === '0.00') && <TableCell align="right">{invoice.currencyprefix}-{trans.amountout} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>}

                                                                </TableRow>
                                                            ))}
                                                        </>
                                                    }
                                                    {invoice.transactions.length === 0 &&
                                                        <TableRow hover>
                                                            <TableCell colSpan={4} align="center">{t('noRelatedTransactions')}</TableCell>
                                                        </TableRow>
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>

                                </Grid>
                                :
                                <Grid item xs={12} sm={12} md={12} >
                                    <Grid container sx={{ backgroundColor: '#f8f8f8' }} mt={3} mb={3} pb={2}>

                                        <Grid item xs={8}>
                                            <Box sx={{ paddingTop: '16px', paddingLeft: '10px' }}>
                                                <Typography variant='h4' sx={{ display: 'inline', pr: 1 }}>{t('invoice')} #{invoice.invoiceid}</Typography>
                                                {invoice.invoicestatus === 'Unpaid' &&
                                                    <Chip color="secondary" size="small" label={invoice.invoicestatus} sx={{ borderRadius: 1, marginTop: '-4px', height: '20px', backgroundColor: '#E3E8EE', color: '#53566B' }} />
                                                }
                                                {invoice.invoicestatus === 'Paid' &&
                                                    <Chip size="small" label={invoice.invoicestatus} sx={{ borderRadius: 1, marginTop: '-4px', height: '20px', backgroundColor: '#cbf4c9', color: '#268717' }} />
                                                }
                                                {invoice.invoicestatus === 'Cancelled' &&
                                                    <Chip size="small" label={invoice.invoicestatus} sx={{ borderRadius: 1, marginTop: '-4px', height: '20px', backgroundColor: '#F8DADB', color: '#B72136' }} />
                                                }
                                                {invoice.invoicestatus === 'Refunded' &&
                                                    <Chip size="small" label={invoice.invoicestatus} sx={{ borderRadius: 1, marginTop: '-4px', height: '20px', backgroundColor: '#F8DADB', color: '#B72136' }} />
                                                }
                                            </Box>

                                        </Grid>
                                        <Grid item xs={4} >
                                            <Grid container direction="row" justifyContent="flex-end">
                                                <LoadingButton
                                                    onClick={handleInvoicePdf}
                                                    loading={loading}
                                                    variant="outlined"
                                                    endIcon={<DownloadIcon sx={{ mr: 1, ml: 0 }} />}
                                                    loadingPosition="end"
                                                    sx={{ mt: 1.7, mr: 2, padding: '4px 5px' }}
                                                >
                                                    <PdfIcon sx={{ ml: 1, mr: 1, color: '#686868', fontSize: '2rem' }} />

                                                </LoadingButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Box>
                                        <Grid container spacing={5}>
                                            <Grid item xs={6}>
                                                <Typography variant='subtitule1' color='primary'>{t('billTo')}</Typography>
                                                <Typography variant='body2' color="grey.500">{invoice.invoicepayto}</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant='subtitule1' color='primary'>{t('issuedTo')}</Typography>
                                                <Typography variant='body2' color="grey.500">{invoice.client_companyname}</Typography>
                                                <Typography variant='body2' color="grey.500">{invoice.client_firstname} {invoice.client_lastname}</Typography>
                                                <Typography variant='body2' color="grey.500">{invoice.client_address1}</Typography>
                                                <Typography variant='body2' color="grey.500">{invoice.client_city} {invoice.client_state} {invoice.client_postcode}</Typography>
                                                <Typography variant='body2' color="grey.500">{invoice.client_country}</Typography>
                                            </Grid>
                                        </Grid>

                                    </Box>
                                    <Box mt={5} mb={3} >
                                        <Typography variant='h5' sx={{ mb: 2 }} color='primary'>{t('productsServices')}</Typography>

                                        <TableContainer component={Paper} variant="tbLight2-nk">
                                            <Table aria-label="simple table" size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>{t('description')}</strong></TableCell>
                                                        <TableCell align="right"><strong>{t('amount')}</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>

                                                    {invoice.hostings.map((host) => (
                                                        <TableRow hover key={host.id}>
                                                            <TableCell component="th" scope="row">
                                                                {
                                                                    host.description.split("\n").map((item, idx) => (
                                                                        <span key={idx}>
                                                                            {item}
                                                                            <br />
                                                                        </span>

                                                                    ))
                                                                }
                                                                
                                                            </TableCell>
                                                            <TableCell align="right">{invoice.currencyprefix}{host.amount} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                        </TableRow>
                                                    ))}

                                                    {invoice.promos.map((promo) => (
                                                        <TableRow hover key={promo.id}>
                                                            <TableCell component="th" scope="row">
                                                                {promo.description}
                                                            </TableCell>
                                                            <TableCell align="right">{invoice.currencyprefix}{promo.amount} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                        </TableRow>
                                                    ))}

                                                    {invoice.addons.map((addon) => (
                                                        <TableRow hover key={addon.id}>
                                                            <TableCell component="th" scope="row">
                                                                {addon.description}
                                                            </TableCell>
                                                            <TableCell align="right">{invoice.currencyprefix}{addon.amount} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                        </TableRow>
                                                    ))}


                                                    {invoice.domains.map((domain) => (
                                                        <TableRow hover key={domain.id}>
                                                            <TableCell component="th" scope="row">
                                                                {
                                                                    domain.description.split("\n").map((item, idx) => (
                                                                        <span key={idx}>
                                                                            {item}
                                                                            <br />
                                                                        </span>
                                                                    ))
                                                                }
                                                            </TableCell>
                                                            <TableCell align="right">{invoice.currencyprefix}{domain.amount} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                        </TableRow>
                                                    ))}

                                                    {invoice.customitems.map((item) => (
                                                        <TableRow hover key={item.id}>
                                                            <TableCell component="th" scope="row">
                                                                {item.description}
                                                            </TableCell>
                                                            <TableCell align="right">{invoice.currencyprefix}{item.amount} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                        </TableRow>
                                                    ))}

                                                    {invoice.variousitems.map((item) => (
                                                        <TableRow hover key={item.id}>
                                                            <TableCell component="th" scope="row">
                                                                {item.type === "Invoice" ?
                                                                    <>{item.description} <TooltipInvoiceDetail idinvoice={item.relid} /> </>
                                                                    :
                                                                    <>{item.description}</>
                                                                }
                                                            </TableCell>
                                                            <TableCell align="right">{invoice.currencyprefix}{item.amount} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                        </TableRow>
                                                    ))}

                                                    <TableRow>
                                                        <TableCell> <strong>{t('total')}</strong></TableCell>
                                                        <TableCell align="right">{invoice.currencyprefix}{invoice.total} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </Box>

                                    {/* transactions*/}

                                    <Box mt={5} mb={3}>
                                        <Typography variant='h5' sx={{ mb: 2 }} color='primary'>{t('transactions')}</Typography>
                                        <TableContainer component={Paper} variant="tbLight2-nk">
                                            <Table aria-label="simple table" size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>{t('date')}</strong></TableCell>
                                                        <TableCell><strong>{t('paymentMethodGateway')}</strong></TableCell>
                                                        <TableCell><strong>{t('transactionId')}</strong></TableCell>
                                                        <TableCell align="right"><strong>{t('total')}</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {invoice.transactions.length !== 0 &&
                                                        <>
                                                            {invoice.transactions.map((trans) => (
                                                                <TableRow hover key={trans.id}>
                                                                    <TableCell component="th" scope="row">{trans.date}</TableCell>
                                                                    <TableCell>{trans.gateway}</TableCell>
                                                                    <TableCell>{trans.transid}</TableCell>

                                                                    {(trans.amountin !== '0.00' && trans.amountout === '0.00') && <TableCell align="right">{invoice.currencyprefix}{trans.amountin} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>}
                                                                    {(trans.amountout !== '0.00' && trans.amountin === '0.00') && <TableCell align="right">{invoice.currencyprefix}-{trans.amountout} {!invoice.currencyprefix && (invoice.currencysuffix || 'USD')}</TableCell>}

                                                                </TableRow>
                                                            ))}
                                                        </>
                                                    }
                                                    {invoice.transactions.length === 0 &&
                                                        <TableRow hover>
                                                            <TableCell colSpan={4} align="center">{t('noRelatedTransactions')}</TableCell>
                                                        </TableRow>
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>

                                </Grid>
                            }

                            <Grid item xs={12} sm={12} md={4} align='center'>

                                {invoice.invoicestatus === 'Unpaid' &&
                                    <>
                                        <Typography variant='h5' sx={{ mt: 4, mb: 2, textAlign: 'center' }} color='primary'>{t('choosePaymentMethod')}</Typography>
                                        <Box>
                                            <FormControl sx={{ m: 1, width: 250 }}>
                                                <InputLabel id="labelPayment" sx={{ ml: 1.7, mt: -1 }}>{t('paymentMethod')}</InputLabel>
                                                <Select
                                                    labelId="labelPayment"
                                                    onChange={handleChangePayment}
                                                    value={payment}
                                                    input={<OutlinedInput label={t('paymentMethod')} />}
                                                    size="small"
                                                >
                                                    {invoice.payments.map((pay) => (
                                                        <MenuItem
                                                            key={pay.id}
                                                            value={pay.gateway}
                                                        >
                                                            {pay.value}
                                                        </MenuItem>
                                                    ))}
                                                </Select>

                                                <Box mt={4}>
                                                    {payment === 'banktransfer' &&
                                                        <Button href="https://www.neothek.com/es-bo/efectivo/" variant="contained" color="success" target="_blank" rel="noopener noreferrer" sx={{'&:hover': {color: '#fff'},'&:focus':{color:'#fff'}}}>{t('payInBolivia')}</Button>
                                                    }
                                                    {payment === 'directdebit' &&
                                                        <Button href="https://www.neothek.com/crypto/" variant="contained" target="_blank" rel="noopener noreferrer" sx={{'backgroundColor':'#F3C31B','color':'#000','&:hover': {color: '#000','backgroundColor':'#F3C31B'},'&:focus':{color:'#000'}}}>{t('payWithBinancePay')}</Button>
                                                    }
                                                    {payment === 'inpay' &&
                                                        <Button href="https://www.neothek.com/es-pa/efectivo/" variant="contained" target="_blank" rel="noopener noreferrer" sx={{backgroundColor:'#2B5AB9',color:'#fff','&:hover': {color: '#fff',backgroundColor:'#2B5AB9'},'&:focus':{color:'#fff'}}}>{t('payViaTowerbank')}</Button>
                                                    }
                                                    {payment === 'paypal' &&
                                                        <PayPalButton invoice={invoice} paymethod={payment} />
                                                    }
                                                    {payment === 'tco' &&
                                                        <CheckoutButton invoice={invoice} paymethod={payment} />
                                                    }
                                                    {payment === 'stripe' &&
                                                        <>
                                                            <StripeButtonPayElement invoice={invoice} paymethod={payment} />
                                                        </>
                                                    }
                                                    {payment === 'payu' &&
                                                        <PayuButton invoice={invoice} paymethod={payment} />
                                                    }
                                                    {payment === 'mailin' &&
                                                        <>
                                                            <Button href="https://www.neothek.com/efectivo/" variant="contained" target="_blank" rel="noopener noreferrer" sx={{backgroundColor:'#131313',color:'#F8D819','&:hover': {color: '#F8D819',backgroundColor:'#131313'},'&:focus':{color:'#F8D819'}}}>{t('payWithWesternUnion')}</Button>
                                                            <Typography variant='body2' color="textSecondary">{t('paymentReference')} {invoice.invoiceid}</Typography></>
                                                    }
                                                </Box>
                                            </FormControl>
                                        </Box>

                                    </>
                                }


                            </Grid>


                        </Grid>
                    </Container>
                </Box>

            </>

        )
    }

}

export default Invoice;